<template>
  <div>
    <!-- 设置快问快答弹窗 -->
    <vh-dialog
      :visible.sync="dialogVisible"
      :before-close="cancelExam"
      :close-on-click-modal="false"
      :title="$t('host.k_580001')"
      :modal="false"
      width="640px"
      :custom-class="readOnly ? 'setting-exam-dialog read-only' : 'setting-exam-dialog'"
    >
      <div class="setting-exam-level">
        <h4 class="level_title">{{ $t('host.k_580019') }}</h4>
        <div class="setting-exam-ctx">
          <span class="select-exam" @click.prevent.stop="openSelectDialog">
            <i class="vh-iconfont vh-line-circle-plus-outline"></i>
            {{ $t('host.k_580002') }}
          </span>
          <div class="setting-exam-ctx__tags" v-if="checkedExamList.length">
            <div
              :class="['tags__item', item.error_status == 1 ? 'tags__error' : '']"
              v-for="item in checkedExamList"
              :key="item.id"
            >
              <span class="tags__title">{{ item.title }}</span>
              <span>({{ item.total_score }}分)</span>
              <i class="vh-icon-close" @click.stop="removeItem(item)"></i>
            </div>
          </div>
          <div class="setting-exam-ctx__error" v-if="errorText">{{ errorText }}</div>
        </div>
      </div>
      <div class="setting-exam-level">
        <h4>{{ $t('host.k_580004') }}</h4>
        <vh-radio-group
          v-model="setScoreForm.type"
          class="setting-exam-radios"
          @input="changeValue"
        >
          <vh-radio :label="1">
            <div class="setting-exam-radios__ctx">
              <p :class="['score--text', setScoreForm.type == 1 ? 'active' : '']">
                {{ $t('host.k_580005') }}
              </p>
            </div>
          </vh-radio>
          <vh-radio :label="2">
            <div class="setting-exam-radios__ctx">
              <p :class="['score--text', setScoreForm.type == 2 ? 'active' : '']">
                {{ $t('host.k_580006') }}
              </p>
              <div v-if="setScoreForm.type == 2" class="score--setting">
                <label>{{ $t('host.k_580007') }}</label>
                <vh-input
                  :placeholder="$t('host.k_580008')"
                  type="number"
                  v-model.trim="setScoreForm.score"
                  size="small"
                ></vh-input>
              </div>
            </div>
          </vh-radio>
          <vh-radio :label="3">
            <div class="setting-exam-radios__ctx">
              <p :class="['score--text', setScoreForm.type == 3 ? 'active' : '']">
                {{ $t('host.k_580009') }}
              </p>
              <div v-if="setScoreForm.type == 3" class="score--setting">
                <label>{{ $t('host.k_580010') }}</label>
                <vh-input
                  :placeholder="$t('host.k_580008')"
                  type="number"
                  v-model.trim="setScoreForm.totalScore"
                  size="small"
                ></vh-input>
                <span v-if="checkedExamList.length">
                  {{ $t('host.k_580011', [checkTotal]) }}
                </span>
              </div>
              <div class="setting-exam-ctx__error" v-if="errorTotalText">
                {{ errorTotalText }}
              </div>
            </div>
          </vh-radio>
        </vh-radio-group>
      </div>
      <!-- 按钮区间 -->
      <span slot="footer" class="dialog-footer" v-if="!readOnly">
        <vh-button size="medium" type="info" plain round @click="cancelExam">
          {{ $t('host.k_580012') }}
        </vh-button>
        <vh-button size="medium" type="primary" v-preventReClick round @click="sureExam">
          {{ $t('host.k_580013') }}
        </vh-button>
      </span>
    </vh-dialog>

    <!-- 选择快问快答弹窗 -->
    <checked-exam
      ref="checkedExamDialog"
      :checkedExamList="checkedExamList"
      @checkExam="checkExam"
    ></checked-exam>
  </div>
</template>
<script>
  import { useExamServer } from 'middle-domain';
  const examServer = useExamServer();
  import regRule from '@/app-shared/utils/reg-rule.js';
  import CheckedExam from './checked-exam.vue';
  export default {
    data() {
      return {
        dialogVisible: false,
        lotteryId: '',
        setScoreForm: {
          type: 1,
          score: '',
          totalScore: ''
        },
        errorTotalText: '',
        errorText: '',
        checkedExamList: []
      };
    },
    props: {
      readOnly: {
        type: Boolean,
        default: false
      }
    },
    provide: { examServer },
    components: {
      CheckedExam
    },
    computed: {
      checkTotal() {
        if (!this.checkedExamList.length) return;
        return this.checkedExamList.reduce((acc, cur) => {
          return acc + Number(cur.total_score);
        }, 0);
      }
    },
    async created() {
      examServer.init(); // 先执行,防止打开弹窗加载时间太长
    },
    methods: {
      // 打开 - 弹窗
      open(id, info) {
        this.dialogVisible = true;
        this.lotteryId = id || '';
        this.errorText = '';
        this.errorTotalText = '';
        const qaInfo = JSON.parse(JSON.stringify(info));
        this.resetInfo(qaInfo);
      },
      resetInfo(info) {
        this.setScoreForm.type = info.type;
        info.type == 2
          ? (this.setScoreForm.score = info.score)
          : (this.setScoreForm.totalScore = info.score);
        this.checkedExamList = info.fqa_list || [];
      },
      changeValue() {
        this.handleResetInfo();
        this.errorText = '';
        this.errorTotalText = '';
      },
      // 关闭 - 弹窗
      handleClose() {
        this.setScoreForm.score = '';
        this.setScoreForm.totalScore = '';
        this.dialogVisible = false;
        this.handleResetInfo();
      },
      // 移除 - 单个选中
      removeItem(item) {
        this.checkedExamList.splice(this.checkedExamList.indexOf(item), 1);
      },
      handleResetInfo() {
        this.checkedExamList = this.checkedExamList.map(item => {
          item.error_status = 0;
          return item;
        });
      },
      checkExam(list) {
        this.checkedExamList.push(...list);
        // let id = 'id';
        // this.checkedExamList = this.checkedExamList.reduce(
        //   (all, next) => (all.some(atom => atom[id] == next[id]) ? all : [...all, next]),
        //   []
        // );
        console.log(this.checkedExamList, '快问快答去重');
      },
      // 确定 - 设置快问快答
      sureExam() {
        const checkList = this.checkedExamList.map(item => item.id);
        if (!checkList.length) {
          this.$message.error(this.$t('host.k_580014'));
          return;
        }
        if (this.setScoreForm.type != 1) {
          const pattern = regRule.positiveInt; // 正整数的正则表达式
          let value =
            this.setScoreForm.type == 2 ? this.setScoreForm.score : this.setScoreForm.totalScore;
          if (!value || !pattern.test(value)) {
            this.$message.error(this.$t('host.k_580015'));
            return;
          }
        }
        const params = {
          ids: checkList.join(','),
          type: this.setScoreForm.type,
          score:
            this.setScoreForm.type == 2 ? this.setScoreForm.score : this.setScoreForm.totalScore
        };
        examServer
          .checkFqaScore(params)
          .then(res => {
            if (res.code === 200) {
              if (res.data.pass_status) {
                const examInfo = {
                  type: this.setScoreForm.type,
                  score:
                    this.setScoreForm.type == 2
                      ? this.setScoreForm.score
                      : this.setScoreForm.totalScore,
                  fqa_list: this.checkedExamList
                };
                this.errorText = '';
                this.handleClose();
                this.$emit('selectExam', examInfo);
              } else {
                this.errorHandle(res.data);
              }
            } else {
              this.$message.error(res.msg);
              this.dialogVisible = true;
            }
          })
          .catch(res => {
            this.dialogVisible = true;
            this.$message.error(res.msg);
          });
      },
      errorHandle(data) {
        const repeatList = data?.deleted_ids || [];
        const singleScoreList = data?.single_score_dissatisfy_ids || [];
        const totalScore = data?.total_score_dissatisfy || false;
        if (repeatList.length) {
          this.errorTotalText = '';
          this.errorText = this.$t('host.k_580016');
          this.checkedExamList = this.checkedExamList.map(item => {
            if (repeatList.includes(Number(item.id))) {
              item.error_status = 1;
            } else {
              item.error_status = 0;
            }
            return item;
          });
          return;
        }
        if (singleScoreList.length) {
          this.errorTotalText = '';
          this.errorText = this.$t('host.k_580017');
          this.checkedExamList = this.checkedExamList.map(item => {
            if (singleScoreList.includes(Number(item.id))) {
              item.error_status = 1;
            } else {
              item.error_status = 0;
            }
            return item;
          });
          return;
        }

        if (totalScore) {
          this.errorText = '';
          this.errorTotalText = this.$t('host.k_580018');
        }
        this.dialogVisible = true;
      },
      // 取消 - 设置快问快答
      cancelExam() {
        this.handleClose();
      },
      // 打开资料库
      openSelectDialog() {
        console.log('openSelectDialog:', this.$refs.checkedExamDialog);
        this.$refs.checkedExamDialog.open();
      }
    }
  };
</script>
<style lang="less">
  .setting-exam-dialog {
    .dialog-footer {
      display: flex;
      justify-content: right;
    }
    &.read-only .vh-dialog__body {
      position: relative;
      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(255, 255, 255, 0.5);
        z-index: 10;
      }
    }
  }
  .setting-exam-level {
    margin-bottom: 12px;
    display: flex;
    &:last-child {
      margin-bottom: 0;
    }
    h4 {
      // margin-bottom: 16px;
      display: inline-block;
      width: 100px;
      text-align: right;
      color: #1a1a1a;
      font-weight: normal;
      font-size: 14px;
      line-height: 40px;
    }
    .level_title {
      line-height: 36px;
    }
    .setting-exam-ctx {
      padding: 0 12px;
      width: calc(100% - 100px);
      .select-exam {
        display: inline-block;
        background: #fff;
        width: 148px;
        height: 36px;
        border: 1px solid #d9d9d9;
        border-radius: 50px;
        font-size: 14px;
        color: #262626;
        line-height: 34px;
        text-align: center;
        cursor: pointer;
        i {
          vertical-align: bottom;
          color: rgba(0, 0, 0, 0.85);
        }
        &:hover {
          background: #fb3a32;
          color: #fff;
          border: 1px solid transparent;
          i {
            color: #fff;
          }
        }
      }
      .setting-exam-ctx__tags {
        margin-top: 16px;
        max-height: 132px;
        overflow-y: auto;
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
        .tags__item {
          padding: 3px 12px;
          background: #f0f0f0;
          border-radius: 50px;
          cursor: pointer;
          span {
            color: #595959;
            font-size: 14px;
          }
          .tags__title {
            display: inline-block;
            max-width: 200px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            vertical-align: middle;
            padding-right: 5px;
            line-height: 20px;
          }
          .vh-icon-close {
            font-size: 12px;
            color: #595959;
            cursor: pointer;
            padding-left: 5px;
          }
          &:hover {
            background: #fff2f0;
            span {
              color: #fb3a32;
            }
            .vh-icon-close {
              color: #fb3a32;
            }
          }
          &.tags__error {
            background: #fff2f0;
            border: 1px solid #fb3a32;
            span {
              color: #fb3a32;
            }
            .vh-icon-close {
              color: #fb3a32;
            }
          }
        }
      }
      &__error {
        color: #fb3a32;
        font-size: 14px;
        padding-top: 8px;
      }
    }
    .setting-exam-radios {
      display: flex;
      justify-content: space-evenly;
      flex-direction: column;
      align-items: baseline;
      padding: 0 12px;
      width: calc(100% - 100px);
      .vh-radio {
        display: flex;
        // margin-bottom: 14px;
        &__input {
          line-height: 45px;
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
      .setting-exam-radios__ctx {
        color: rgba(0, 0, 0, 0.65);
        .score--setting {
          // margin-top: 12px;
          white-space: normal;
          word-wrap: break-word;
          overflow-wrap: break-word;

          label {
            margin-right: 8px;
          }
          .vh-input,
          input {
            width: 160px;
          }
          span {
            margin-left: 8px;
          }
        }
        .score--text {
          // color: rgba(0, 0, 0, 0.65);
          &.active {
            color: rgba(0, 0, 0, 0.85);
          }
        }
        .vh-input__inner {
          line-height: 1px !important;
        }
      }
    }
  }
</style>
